import { Rectangle3D } from '@3d-scene/model/rectangle-3d';

export class TextureConnectionInfo {
  private _id: string;
  private _rectangle: Rectangle3D;
  private _connectionWidth: number;
  private _connectionHeight: number;
  private _distanceToPreviousConnection: number;
  private _type: string;

  public constructor(id: string, rectangle: Rectangle3D, distanceToPreviousConnection: number, type: string) {
    this._id = id;
    this._rectangle = rectangle;
    this._connectionWidth = rectangle.width;
    this._connectionHeight = rectangle.height;
    this._distanceToPreviousConnection = distanceToPreviousConnection;
    this._type = type;
  }

  public get id(): string {
    return this._id;
  }

  public get rectangle(): Rectangle3D {
    return this._rectangle;
  }

  public get distanceToPreviousConnection(): number {
    return this._distanceToPreviousConnection;
  }

  public get connectionWidth(): number {
    return this._connectionWidth;
  }

  public get connectionHeight(): number {
    return this._connectionHeight;
  }

  public get type(): string {
    return this._type;
  }
}
